/**
 * AI Studio home — RBAC-filtered hub for decision agents, factory, and AI settings.
 */

import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '@/state/language/LanguageProvider';
import { AIStudioHomeTileGrid } from '@/components/ai-studio/home/AIStudioHomeTileGrid';
import { useAIStudioHomeTiles } from '@/components/ai-studio/home/useAIStudioHomeTiles';

const AIStudioHomePage: React.FC = () => {
  const { t } = useLanguage();
  const { groups, loading } = useAIStudioHomeTiles();

  return (
    <main className="flex w-full flex-col gap-4 px-4 py-4 md:px-6 lg:px-8">
      <header className="flex items-start gap-3">
        <SparklesIcon className="h-7 w-7 shrink-0 text-[var(--color-primary-text)]" aria-hidden />
        <div>
          <h1 className="text-lg font-semibold text-[var(--color-surface-text)]">
            {t('aiStudio.home.title')}
          </h1>
          <p className="mt-1 text-base text-[var(--color-surface-text-secondary)]">
            {t('aiStudio.home.subtitle')}
          </p>
        </div>
      </header>

      {loading && (
        <p className="text-base text-[var(--color-surface-text-secondary)]">
          {t('aiStudio.home.loading')}
        </p>
      )}

      {!loading && groups.length === 0 && (
        <p className="text-base text-[var(--color-surface-text-secondary)]">
          {t('aiStudio.home.empty')}
        </p>
      )}

      {!loading && groups.length > 0 && <AIStudioHomeTileGrid groups={groups} />}
    </main>
  );
};

export default AIStudioHomePage;
